import React, { Component } from 'react';
import cx from 'classnames';
import ReactDOM from 'react-dom';
import memoizeOne from 'memoize-one';
import ActionPopup from '../../../../ActionPopup';
import onEnterPressed from '../../../../../common/utils/onEnterPressed';
import UserDetails from '../../ListItem/components/UserDetails';
import { LIST_ITEM } from '../../ListItem/styles/listItem';
import '../styles/_pitch-list-item.scss';





















class PitchListItem extends Component {
  /**
   * @param {Function} fn
   *
   * @return {Function}
   *
   * Prevent event propogation to parent DOM elements.
   * Parent DOM elements onClick handlers should not be triggered.
   *
   */
  withNoEventPropagation = memoizeOne((fn) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    fn(e);
  });

  wrapPopupOptionsWithStopEvent = memoizeOne((popupOptions) => popupOptions.map((option) => ({
    ...option,
    action: this.withNoEventPropagation(option.action)
  })));

  constructor(props) {
    super(props);

    this.state = {};
  }

  /**
   * Invoke onClick only when click is not in the ActionPopup ref.
   * @param {Function} onClickProp
   *
   * @return {Function}
   */
  onClick = (onClickProp) => this.withNoEventPropagation((e) => {
    const { actionBtnRef } = this.state;

    if (actionBtnRef && actionBtnRef.contains(e.target) || !onClickProp) {return;}

    onClickProp(e);
  });

  /**
   * Capture ActionPopup ref
   */
  setActionPopupRef = memoizeOne((el) => {
    if (!el) {
      return;
    }
    // eslint-disable-next-line react/no-find-dom-node
    this.setState({ actionBtnRef: ReactDOM.findDOMNode(el) });
  });

  static UserDetails = UserDetails;

  render() {
    const {
      children,
      rightSideChildren,
      onClick: onClickProp,
      actionPopupOptions,
      className,
      itemStatus,
      actionPopupConfig
    } = this.props;

    return (
      <div
        className={cx('list-item', LIST_ITEM({ onClick: onClickProp }), className)}
        onClick={this.onClick(onClickProp)}
        role="button"
        onKeyDown={onEnterPressed({ onClick: this.onClick(onClickProp) })}
        tabIndex={0}>

        <div className="list-item__left-side">
          {children}
        </div>

        <div className="list-item__right-side">
          {rightSideChildren || null}
          {itemStatus ?
          <div className="list-item__right-side__status item">
              {itemStatus && itemStatus.charAt(0).toUpperCase() + itemStatus.slice(1).toLowerCase()}
            </div> :
          null}

          {actionPopupOptions ?
          <ActionPopup
            options={this.wrapPopupOptionsWithStopEvent(actionPopupOptions)}
            ref={this.setActionPopupRef}
            actionPopupConfig={actionPopupConfig} /> :

          null}
        </div>
      </div>);

  }
}

export default PitchListItem;